import LegalPageLayout from './LegalPageLayout';

export default function CGU() {
  return <LegalPageLayout pageKey="cgu" />;
}
